<template lang="pug">
menu-button-menu(@open="active = true", @close="active = false", :menuZIndex="99999")
  i.material-icons.md-18(:class="{ active: active || hover }", @mouseenter="hover = true", @mouseout="hover = false") menu
  template(slot="contextmenu")
    slot
</template>


<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  data() {
    return { active: false, hover: false}
  },
})
</script>


<style lang="scss" scoped>
i {
  cursor: default;
  vertical-align: bottom;
}

.active {
  text-shadow: 0 0 8pt white;
}
</style>